import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import UserService from "../../../Modules/Services/user.service.ts";
import "./Login.css";
import "../Admin.css";

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await UserService.login(username, password);
      navigate("/admin/dashboard");
    } catch {
      setError("Неверный логин или пароль.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__card surface">
        <h1 className="login-page__title">Вход в админ-панель</h1>
        <p className="login-page__lead muted">Шахризада</p>

        {error ? (
          <div className="admin-flash admin-flash--error" role="alert">
            <span>{error}</span>
            <button
              type="button"
              className="admin-flash__dismiss"
              onClick={() => setError("")}
              aria-label="Закрыть"
            >
              ×
            </button>
          </div>
        ) : null}

        <form className="login-page__form" onSubmit={onSubmit}>
          <div className="admin-field">
            <label className="admin-field__label" htmlFor="login-user">
              Имя пользователя
            </label>
            <input
              id="login-user"
              className="admin-input"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="admin-field">
            <label className="admin-field__label" htmlFor="login-pass">
              Пароль
            </label>
            <input
              id="login-pass"
              type="password"
              className="admin-input"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="btn btn--primary"
            style={{ width: "100%", marginTop: "0.25rem" }}
            disabled={loading}
          >
            {loading ? "Вход…" : "Войти"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
